import template from './template.v3.json' with { type: "json" };
import packageInfo from '../package.json' with { type: "json" };
import { createVirtualMachineBch, generateTransaction, hexToBin, verifyTransactionTokens, utf8ToBin, isHex } from '@bitauth/libauth';
import { getAddress, getLibauthCompiler, getScriptHash, } from '@unspent/tau';
export default class SmallIndex {
    static USER_AGENT = packageInfo.name;
    static PROTOCOL_IDENTIFIER = "U3R";
    static VERSION = "1.0.0";
    static tokenAware = true;
    static template = template;
    static compiler = getLibauthCompiler(this.template);
    static vm = createVirtualMachineBch();
    static parseKey(indexKey) {
        if (typeof indexKey == "string") {
            if (isHex(indexKey)) {
                indexKey = hexToBin(indexKey);
            }
            else {
                indexKey = utf8ToBin(indexKey);
            }
        }
        return indexKey;
    }
    static getLockingBytecode(indexKey) {
        const lockingBytecodeResult = this.compiler.generateBytecode({
            data: {
                "bytecode": {
                    "key": this.parseKey(indexKey)
                }
            },
            scriptId: 'lock'
        });
        if (!lockingBytecodeResult.success)
            throw new Error('Failed to generate bytecode, script: , ' + JSON.stringify(lockingBytecodeResult, null, '  '));
        return lockingBytecodeResult.bytecode;
    }
    /**
     * Get cashaddress
     *
     * @param indexKey - the key for the record.
     * @param reversed - whether to reverse the hash.
     * @throws {Error} if transaction generation fails.
     * @returns a cashaddress.
     */
    static getScriptHash(indexKey, reversed = true) {
        return getScriptHash(this.getLockingBytecode(indexKey), reversed);
    }
    /**
     * Get cashaddress
     *
     * @param indexKey - the key for the record.
     * @param prefix - cashaddress prefix.
     * @throws {Error} if transaction generation fails.
     * @returns a cashaddress.
     */
    static getAddress(indexKey, prefix = "bitcoincash") {
        return getAddress(this.getLockingBytecode(indexKey), prefix, this.tokenAware);
    }
    static getSourceOutput(indexKey, utxo) {
        return {
            lockingBytecode: this.getLockingBytecode(indexKey),
            valueSatoshis: BigInt(utxo.value)
        };
    }
    static getSourceOutputs(indexKey, utxos) {
        return utxos.map((u) => {
            return this.getSourceOutput(indexKey, u);
        });
    }
    static getInput(indexKey, utxo) {
        return {
            outpointIndex: utxo.tx_pos,
            outpointTransactionHash: hexToBin(utxo.tx_hash),
            sequenceNumber: utxo.value,
            unlockingBytecode: {
                data: {
                    "bytecode": {
                        "key": this.parseKey(indexKey)
                    }
                },
                compiler: this.compiler,
                script: 'unlock',
                valueSatoshis: BigInt(utxo.value),
            },
        };
    }
    static getInputs(indexKey, utxos) {
        return utxos.map((u) => {
            return this.getInput(indexKey, u);
        });
    }
    static getOutput() {
        return {
            lockingBytecode: {
                data: {},
                compiler: this.compiler,
                script: 'op_return'
            },
            valueSatoshis: BigInt(0)
        };
    }
    /**
     * Drop expired records.
     *
     * @param indexKey - The index key for the record being dropped
     * @param utxos - List of records to drop.
     *
     * @throws {Error} if transaction generation fails.
     * @returns a transaction template.
     */
    static drop(indexKey, utxos) {
        const inputs = [];
        const outputs = [];
        let config = {
            locktime: 0,
            version: 2,
            inputs,
            outputs
        };
        config.inputs.push(...this.getInputs(indexKey, utxos));
        config.outputs.push(this.getOutput());
        let result = generateTransaction(config);
        if (!result.success)
            throw new Error('generate transaction failed!, errors: ' + JSON.stringify(result.errors, null, '  '));
        const sourceOutputs = [...this.getSourceOutputs(indexKey, utxos)];
        const transaction = result.transaction;
        const tokenValidationResult = verifyTransactionTokens(transaction, sourceOutputs, { maximumTokenCommitmentLength: 40 });
        if (tokenValidationResult !== true)
            throw tokenValidationResult;
        let verify = this.vm.verify({
            sourceOutputs: sourceOutputs,
            transaction: transaction,
        });
        if (typeof verify == "string")
            throw Error(verify);
        return {
            sourceOutputs: sourceOutputs,
            transaction: transaction,
            verify: verify
        };
    }
}
//# sourceMappingURL=index.js.map